import router from './router/index.js';
import store from './store/index.js';

export {
    router,
    store
};
